import React, {FC} from 'react';

import './counter.less';

export interface ICounterProps {
        count: number;
        color?: string;
}

export const Counter: FC<ICounterProps> = ({count, color = 'gray'}: ICounterProps) => {
    const className = `counter ${color}`;
    return (
        <div className={className}>
            {count}
        </div>
    );
};
